import React from "react";
import {connect} from "react-redux";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {IMapas, INotificacion, IParcela, ISections} from "../../../types";
import TextField from "@material-ui/core/TextField";
import {Search, ArrowDropUp, Save} from '@material-ui/icons';
import {Button, FormControl, InputLabel, MenuItem, Paper, Select, Typography} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import L, {LatLngTuple} from "leaflet";
import {FeatureGroup, Map, Marker, Polygon, TileLayer, ZoomControl} from "react-leaflet";
import SenseorIcon from "../../../icons/PNGs/sensor.png";
import axios from "axios";
import config from "../../../config.json";
import {userService} from "../../../services/UserService";

const texts = require('../../../texts/estaciones.json');

const sensor_icon = new L.Icon({
    iconUrl: SenseorIcon,
    iconRetinaUrl: SenseorIcon,
    iconSize: [30, 75],
    iconAnchor: [15, 50]
})

const urls = {
    satelite: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    carreteras: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
}

interface IProps {
    setEstaciones(estaciones: Record<string, any>[]): void
    notify(notification: INotificacion): void
    menu: boolean
    idioma: string
    estaciones: Record<string, any>[]
    sensores: Record<string, any>[]
    cotas_sensores: Record<number, string[]>
    parcelas: IParcela[]
}

interface Istate {
    text: Record<string, string>
    searchEstacion: string
    searchSensor: string
    searchParcela: string
    estacionesfiltradas: Record<string, any>[]
    hover: string
    selected: Record<string, any> | null
    openedAutocompleteParcela: boolean
    mapa: IMapas
    zoom: number
    center: LatLngTuple
}

class Estaciones extends React.Component<IProps, Istate> {

    state:Istate = {
        text: texts[this.props.idioma],
        searchEstacion: "",
        searchSensor: "",
        searchParcela: "",
        estacionesfiltradas: this.props.estaciones,
        hover: "",
        selected: null,
        openedAutocompleteParcela: false,
        mapa: 'satelite' as IMapas,
        zoom: 18 as number,
        center: [40, -3.7] as LatLngTuple
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    handleSearchByEstacion = async (search: string) => {
        await this.setState({searchEstacion: search})
        await this.filterEstaciones()
    }

    handleSearchBySensor = async (search: string) => {
        await this.setState({searchSensor: search})
        await this.filterEstaciones()
    }

    handleSearchByParcela = async (search: string) => {
        await this.setState({searchParcela: search})
        await this.filterEstaciones()
    }

    filterEstaciones = async () => {
        const searchEstacion = this.state.searchEstacion
        const searchSensor = this.state.searchSensor
        const searchParcela = this.state.searchParcela

        const estacionesfiltradas: Record<string, any>[] = []
        for (const estacion of this.props.estaciones) {

            if (searchEstacion.length > 0) {
                const nombreEstacion = estacion.cropsense_name !== null? estacion.cropsense_name : estacion.name
                if (!nombreEstacion.toLowerCase().includes(searchEstacion.toLowerCase())) continue
            }

            if (searchSensor.length > 0) {
                const sensores = estacion.sensors
                    .map((sensor: Record<string, any>) => sensor.name)
                    .join(", ")
                if (!sensores.toLowerCase().includes(searchSensor.toLowerCase())) continue
            }

            if (searchParcela.length > 0) {
                if (estacion.cropsense_parcela === null) continue
                let cropsense_parcela_name = null
                const parcelas = this.props.parcelas.filter((parcela) =>
                    parcela.id === estacion.cropsense_parcela
                )
                if (parcelas.length > 0) {
                    cropsense_parcela_name = parcelas[0].nombre
                }
                if (cropsense_parcela_name === null) continue
                if (!cropsense_parcela_name.toLowerCase().includes(searchParcela.toLowerCase())) continue
            }

            estacionesfiltradas.push(estacion)
        }

        await this.setState({estacionesfiltradas: estacionesfiltradas})

    }



    handleUpdate = () => {
        if (this.state.selected === null) return
        const data = {
            id: this.state.selected.id,
            cropsense_name: this.state.selected.cropsense_name,
            cropsense_lat: this.state.selected.cropsense_lat,
            cropsense_lng: this.state.selected.cropsense_lng,
            cropsense_parcela: this.state.selected.cropsense_parcela,
            cropsense_sensors: this.state.selected.cropsense_sensors,
        }

        axios.post(
            config.url+`/update/station`,
            data,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {

                axios.get(
                    config.url+'/get/all/stations',
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res: { data: Record<string, any>[] }) => {
                        this.props.setEstaciones(res.data)
                        this.setState({
                            estacionesfiltradas: res.data,
                            selected: null,
                            searchEstacion: "",
                            searchParcela: "",
                            searchSensor: ""
                        })

                        this.props.notify({message: this.state.text["8"], variant: 'success'})
                    })
                    .catch(() => {
                        this.props.notify({message: this.state.text["9"], variant: 'error'})
                    })

            })
            .catch(() => {
                this.props.notify({message: this.state.text["9"], variant: 'error'})
            })

    }
    
    renderShort = (estacion: Record<string, any>) => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: 60,
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden"
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: "center",
                        height: 60,
                        width: "30%",
                        minWidth: "fit-content"
                    }}
                >
                    <Typography
                        style={{
                            marginLeft: 60,
                            marginRight: 20,
                            fontSize: 18,
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["1"]}
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins"
                        }}
                    >
                        {estacion.cropsense_name !== null ? estacion.cropsense_name : estacion.name}
                    </Typography>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: "center",
                        height: 60,
                        width: "40%",
                        minWidth: "fit-content"
                    }}
                >
                    <Typography
                        style={{
                            marginLeft: 20,
                            marginRight: 20,
                            fontSize: 18,
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["2"]}
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins"
                        }}
                    >
                        {
                            estacion.sensors
                                .map((sensor: Record<string, any>) => sensor.name)
                                .join(", ")
                        }
                    </Typography>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: "center",
                        height: 60,
                        width: "25%",
                        minWidth: "fit-content"
                    }}
                >
                    <Typography
                        style={{
                            marginLeft: 20,
                            marginRight: 20,
                            fontSize: 18,
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["3"]}
                    </Typography>
                    <Typography
                        style={{
                            marginRight: 20,
                            fontSize: 18,
                            fontWeight: "bold",
                            whiteSpace: 'nowrap',
                            fontFamily: "Poppins",
                            color: estacion.cropsense_parcela ? "#000000" : "#BBBB"
                        }}
                    >
                        {estacion.cropsense_parcela !== null ?
                            this.props.parcelas.filter(
                                (parcela) => parcela.id === estacion.cropsense_parcela
                            )[0].nombre
                            :
                            "Sin asignar"
                        }
                    </Typography>
                </div>
            </div>
        )
    }

    renderLong = (estacion: Record<string, any>) => {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    height: "fit-content",
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden"
                }}
            >
                {this.renderShort(estacion)}

                <div
                    style={{
                        width: "calc(100% - 60px)",
                        height: 2,
                        backgroundColor: "#888888"
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        height: "fit-content",
                    }}
                    id={"parent"}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "30%",
                            aspectRatio: "1",
                            justifyContent: "space-between",
                        }}
                    >

                        <div>
                            <form
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '80%',
                                    alignItems: "flex-start",
                                    marginLeft: 30
                                }}
                            >
                                <TextField
                                    style={{
                                        width: 250,
                                        fontFamily: "Poppins",
                                        marginTop: 20
                                    }}
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    value={this.state.selected?.cropsense_name}
                                    onChange={(e) => {
                                        const selected = {
                                            ...this.state.selected,
                                            cropsense_name: e.target.value
                                        }
                                        this.setState({selected: selected})
                                    }}
                                    label={this.state.text["4"]}
                                />
                            </form>

                            <form
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '80%',
                                    alignItems: "flex-start",
                                    marginLeft: 30,
                                    marginTop: 30
                                }}
                            >
                                <Typography
                                    color={"primary"}
                                    style={{
                                        marginBottom: -20,
                                        fontSize: 12,
                                        color: this.state.openedAutocompleteParcela ? "" : "#666",
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {this.state.text["5"]}
                                </Typography>
                                <Autocomplete
                                    id="combo-box-demo"
                                    style={{
                                        width: 250,
                                        fontFamily: "Poppins",
                                        marginTop: 20
                                    }}
                                    value={{
                                        id: this.state.selected?.cropsense_parcela,
                                        nombre: this.state.selected?.cropsense_parcela_name
                                    }}
                                    disableClearable
                                    options={this.props.parcelas.map((parcela) => {
                                        return {
                                            id: parcela.id,
                                            nombre: parcela.nombre
                                        }
                                    })}
                                    getOptionLabel={(option) => option.nombre}
                                    onOpen={() => this.setState({openedAutocompleteParcela: true})}
                                    onClose={() => this.setState({openedAutocompleteParcela: false})}
                                    onChange={(e, v) => {
                                        const selected = {
                                            ...this.state.selected,
                                            cropsense_parcela: v.id,
                                            cropsense_parcela_name: v.nombre
                                        }
                                        this.setState({selected: selected})
                                    }}
                                    renderInput={(params) =>
                                        <div
                                            style={{
                                                marginBottom: 10
                                            }}
                                        >
                                            <TextField
                                                {...params}
                                            />
                                        </div>
                                    }
                                />
                            </form>
                        </div>


                        <Button
                            variant="contained"
                            color={"secondary"}
                            style={{
                                height: 50,
                                marginLeft: 30,
                                width: "80%",
                            }}
                            onClick={() => this.handleUpdate()}
                        >
                            <Save
                                style={{
                                    width: 40,
                                    height: 40
                                }}
                            />
                        </Button>


                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "30%",
                            height: "fit-content",
                        }}
                    >

                        {this.state.selected?.cropsense_sensors.map((sensor: Record<string, any>) => {
                            const sensorName = this.props.sensores.filter((el) => el.id === sensor.id)[0].name
                            const cotas = this.props.cotas_sensores[sensor.id]
                            return (
                                <form
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: '100%',
                                        alignItems: "flex-start",
                                        margin: 20
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontFamily: "Poppins",
                                            marginBottom: -10
                                        }}
                                    >
                                        {sensorName}
                                    </Typography>
                                    {cotas.map((cota) =>
                                        <TextField
                                            style={{
                                                width: 250,
                                                fontFamily: "Poppins",
                                                marginTop: 20
                                            }}
                                            inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                            InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                            type="number"
                                            value={sensor[cota]}
                                            onChange={(e) => {
                                                const cropsense_sensors = []
                                                for (const el of this.state.selected?.cropsense_sensors) {
                                                    if (el.id !== sensor.id) {
                                                        cropsense_sensors.push(el)
                                                    } else {
                                                        cropsense_sensors.push({
                                                            ...el,
                                                            [cota]: e.target.value
                                                        })
                                                    }
                                                }
                                                const selected = {
                                                    ...this.state.selected,
                                                    cropsense_sensors: cropsense_sensors
                                                }
                                                this.setState({selected: selected})
                                            }}
                                            label={this.state.text[cota]}
                                        />
                                    )}
                                </form>
                            )
                        })}

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: 20,
                            width: "calc(40% - 30px)",
                            aspectRatio: "1"
                        }}
                    >

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                height: '100%'
                            }}
                        >

                            <Map
                                center={this.state.center}
                                zoom={this.state.zoom}
                                maxZoom={22}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 20,
                                    zIndex: 1
                                }}
                                onmoveend={(e) => {
                                    this.setState({
                                        zoom: e.target.getZoom(),
                                        center: [e.target.getCenter().lat, e.target.getCenter().lng]
                                    })
                                }}
                                zoomControl={false}
                            >
                                <ZoomControl
                                    position={'topright'}
                                />
                                <TileLayer url={urls.satelite}/>

                                {this.state.selected?.cropsense_parcela !== null ?
                                    <Polygon
                                        key={this.state.selected?.cropsense_parcela}
                                        positions={this.props.parcelas.filter((parcela: IParcela) => parcela.id === this.state.selected?.cropsense_parcela)[0].lat_lon}
                                        color={'rgb(255,255,255)'}
                                        fillColor={'rgb(255,255,255,0)'}
                                    />
                                    :
                                    <div/>
                                }

                                <Marker
                                    draggable={true}
                                    position={[this.state.selected?.cropsense_lat, this.state.selected?.cropsense_lng] as LatLngTuple}
                                    icon={sensor_icon}
                                    ondragend={(e) => {
                                        const selected = {
                                            ...this.state.selected,
                                            cropsense_lat: e.target.getLatLng().lat,
                                            cropsense_lng: e.target.getLatLng().lng
                                        }
                                        this.setState({selected: selected})
                                    }}
                                />


                            </Map>

                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: "center",
                                justifyContent: "center",
                                width: '100%',
                                height: 80
                            }}
                        >

                            <form
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '150',
                                    alignItems: "flex-start",
                                }}
                            >
                                <TextField
                                    style={{
                                        width: 120,
                                        fontFamily: "Poppins",
                                        marginTop: 20
                                    }}
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    type="number"
                                    value={
                                        Math.round(this.state.selected?.cropsense_lat*1000000)/1000000
                                    }
                                    onChange={(e) => {
                                        const selected = {
                                            ...this.state.selected,
                                            cropsense_lat: e.target.value
                                        }
                                        this.setState({selected: selected})
                                    }}
                                    label={this.state.text["6"]}
                                />
                            </form>

                            <form
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: 150,
                                    alignItems: "flex-start",
                                    marginLeft: 30
                                }}
                            >
                                <TextField
                                    style={{
                                        width: 120,
                                        fontFamily: "Poppins",
                                        marginTop: 20
                                    }}
                                    inputProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                                    type="number"
                                    value={
                                        Math.round(this.state.selected?.cropsense_lng*1000000)/1000000
                                    }
                                    onChange={(e) => {
                                        const selected = {
                                            ...this.state.selected,
                                            cropsense_lng: e.target.value
                                        }
                                        this.setState({selected: selected})
                                    }}
                                    label={this.state.text["7"]}
                                />
                            </form>

                        </div>

                    </div>

                </div>

                <Button
                    variant="contained"
                    style={{
                        marginTop: 20,
                        height: 30,
                        width: "100%",
                    }}
                    onClick={() => this.setState({selected: null})}
                >
                    <ArrowDropUp
                        style={{
                            width: 40,
                            height: 40
                        }}
                    />
                </Button>

            </div>
        )
    }

    render() {
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#eee',
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginLeft: this.props.menu ? '18%' : '5%',
                        width: this.props.menu ? '82%' : '95%',
                        height: '100%',
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: "100%",
                            width: "90%",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: "center",
                                justifyContent: "space-between",
                                height: 60,
                                width: "95%",
                                marginTop: 30,
                                marginBottom: 10,
                            }}
                        >

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    width: 350,
                                    backgroundColor: 'white',
                                    borderRadius: 30
                                }}
                            >
                                <TextField
                                    style={{
                                        margin: 8,
                                        width: 250,
                                        fontSize: 30
                                    }}
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.searchEstacion}
                                    label={this.state.searchEstacion.length === 0 ? null : this.state.text["f1"]}
                                    placeholder={this.state.text["f1"]}
                                    onChange={(e) => this.handleSearchByEstacion(e.target.value)}

                                />
                                <Search
                                    style={{
                                        width: 30,
                                        height: 30
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    width: 350,
                                    backgroundColor: 'white',
                                    borderRadius: 30
                                }}
                            >
                                <TextField
                                    style={{
                                        margin: 8,
                                        width: 250,
                                        fontSize: 30
                                    }}
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.searchSensor}
                                    label={this.state.searchSensor.length === 0 ? null : this.state.text["f2"]}
                                    placeholder={this.state.text["f2"]}
                                    onChange={(e) => this.handleSearchBySensor(e.target.value)}

                                />
                                <Search
                                    style={{
                                        width: 30,
                                        height: 30
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    width: 350,
                                    backgroundColor: 'white',
                                    borderRadius: 30
                                }}
                            >
                                <TextField
                                    style={{
                                        margin: 8,
                                        width: 250,
                                        fontSize: 30
                                    }}
                                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                                    value={this.state.searchParcela}
                                    label={this.state.searchParcela.length === 0 ? null : this.state.text["f3"]}
                                    placeholder={this.state.text["f3"]}
                                    onChange={(e) => this.handleSearchByParcela(e.target.value)}

                                />
                                <Search
                                    style={{
                                        width: 30,
                                        height: 30
                                    }}
                                />
                            </div>

                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                height: "calc(100% - 110px)",
                                width: "100%",
                                overflow: "auto",
                            }}
                        >
                            {this.state.estacionesfiltradas.map((estacion) =>
                                <Paper
                                    elevation={
                                        this.state.hover === `${estacion.id}`
                                        && this.state.selected?.id !== estacion.id ?
                                            8 : 1
                                    }
                                    style={{
                                        height: "fit-content",
                                        width: "calc(100% - 20px)",
                                        margin: 10,
                                        cursor: this.state.selected?.id !== estacion.id ? "pointer" : "default",
                                        transition: 'box-shadow 0.3s ease-in-out',
                                    }}
                                    onMouseEnter={() => this.setState({hover: `${estacion.id}`})}
                                    onMouseLeave={() => this.setState({hover: ''})}
                                    onClick={() => {
                                        if (this.state.selected === null || this.state.selected?.id !== estacion.id) {
                                            let cropsense_parcela_name = null
                                            const parcelas = this.props.parcelas.filter((parcela) =>
                                                parcela.id === estacion.cropsense_parcela
                                            )
                                            if (parcelas.length > 0) {
                                                cropsense_parcela_name = parcelas[0].nombre
                                            }
                                            const cropsense_sensors = estacion.cropsense_sensors === null ?
                                                [] : estacion.cropsense_sensors
                                            const ok_cropsense_sensors = []
                                            for (const sensor of estacion.sensors) {
                                                let cotaSensor = {id: sensor.id}
                                                for (const cota of this.props.cotas_sensores[sensor.id]) {
                                                    let value = null
                                                    const cropsense_sensor = cropsense_sensors.filter(
                                                        (el: Record<string, any>) => el.id === sensor.id
                                                    )
                                                    if (cropsense_sensor.length > 0 && Object.keys(cropsense_sensor[0]).includes(cota)) {
                                                        value = cropsense_sensor[0][cota]
                                                    }
                                                    cotaSensor = {...cotaSensor, [cota]: value}
                                                }
                                                ok_cropsense_sensors.push(cotaSensor)
                                            }

                                            const cropsense_lat = estacion.cropsense_lat !== null ?
                                                estacion.cropsense_lat : estacion.lat

                                            const cropsense_lng = estacion.cropsense_lng !== null ?
                                                estacion.cropsense_lng : estacion.lng

                                            this.setState({
                                                selected: {
                                                    ...estacion,
                                                    cropsense_parcela_name: cropsense_parcela_name,
                                                    cropsense_sensors: ok_cropsense_sensors,
                                                    cropsense_lat: cropsense_lat,
                                                    cropsense_lng: cropsense_lng,
                                                },
                                                center: [cropsense_lat, cropsense_lng]
                                            })
                                        }
                                    }}
                                >
                                    {this.state.selected?.id === estacion.id?
                                        this.renderLong(estacion)
                                        :
                                        this.renderShort(estacion)
                                    }
                                </Paper>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    idioma: state.config.idioma,
    estaciones: state.principal.estaciones,
    sensores: state.principal.sensores,
    cotas_sensores: state.principal.cotas_sensores,
    parcelas: state.principal.parcelas,
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setEstaciones: (estaciones: Record<string, any>[]) => dispatch({type: "set-principal-estaciones", estaciones}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Estaciones);